import { apiRequest } from './apiService';

export const fetchPaymentConfig = async () => apiRequest('/admin/payment-config');

export const updatePaymentConfig = async (updates) => apiRequest('/admin/payment-config', {
  method: 'PATCH',
  body: updates,
});
